import HttpClient from '../services/HttpClient';
import { APP_URL, POSTULATES_STATUS, VACANT, POSTULATE, POSTULATE_CRITERIAL, POSTULATE_BY_DOC_AND_NUMBER } from '../constants';

export const getPostulatesStatus = () => {
    return new Promise((resolve, reject) => {
        const headers = {
            'Content-Type': 'application/json'
        };
        HttpClient.get(`${APP_URL}${POSTULATES_STATUS}`, headers).then(response => {
            resolve(response);
        }).catch(error => {
            if (typeof error.response === 'undefined') {

                reject({ error: 'technical_error', error_description: 'Occurió un problema comuniquese con el administrador.' });
            }
            reject(error.response);
            resolve(error.response);
        });
    });
}

export const getFilterPostulates = (filters, paginator,) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.post(`${APP_URL}${VACANT}${POSTULATE}${POSTULATE_CRITERIAL}?page=${paginator.page}&size=${paginator.size}&order=${paginator.order}&columnOrder=${paginator.columnOrder}`,
    filters,
    headers
    )
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        resolve(error.response);
      });
  });
};

export const rejectUserPostulate = (rejectUser) => {
  return new Promise((resolve, reject) => {
    const headers = {
      "Content-Type": "application/json",
    };
    HttpClient.put(`${APP_URL}${VACANT}${POSTULATE}`, rejectUser, headers).then(response => {
      resolve(response);
    }).catch((error) => {
      resolve(error.response);
    })
  })
}

export const getPostulateByDocAndNumber = (paginator, body) => {
  const headers = {"Content-Type": "application/json"};
  return new Promise((resolve) => {
    HttpClient.post(`${APP_URL}${POSTULATE_BY_DOC_AND_NUMBER}?page=${paginator.page}&size=${paginator.size}&order=${paginator.order}&columnOrder=${paginator.columnOrder}`, body, headers).then((response) => {
      resolve(response);
    }).catch((error) => {
      resolve(error.response);
    })
  })
}
